import React from 'react';

import { Button, Icon } from '@/nova/components';
import { COLORS } from '@/nova/theme/tokens';
import type { IconName } from '@/nova/components';

import { Wrap, IconRing, Title, Body, Action } from './Notice.styles';

export type NoticeProps = {
  icon?: IconName;
  title: string;
  body?: string;
  actionLabel?: string;
  onAction?: () => void;
  actionBusy?: boolean;
};

/**
 * Centred title/body notice for the page-level states: the affiliate program not
 * being available for a brand, an unverified email blocking provisioning, or a load
 * failure with a retry. Distinct from the shared `EmptyState` (a bare muted line):
 * this one carries an icon and an optional call to action.
 */
export const Notice = ({ icon, title, body, actionLabel, onAction, actionBusy = false }: NoticeProps): React.ReactElement => (
  <Wrap>
    {icon ? (
      <IconRing>
        <Icon name={icon} size={24} color={COLORS.icon} />
      </IconRing>
    ) : null}
    <Title text={title} tag="span" />
    {body ? <Body text={body} tag="span" /> : null}
    {actionLabel && onAction ? (
      <Action>
        <Button label={actionLabel} variant="primary" onClick={onAction} disabled={actionBusy} />
      </Action>
    ) : null}
  </Wrap>
);

export default Notice;
